import { InjectionToken, Type } from '@angular/core';
import { BaseWidgetFactory } from '../widget-factory';
import type { BaseWidget } from './widget-base.model';

/**
 * Generic interface for widget constructors.
 * Uses Angular's Type<T> which represents a constructor function.
 */
export interface WidgetConstructor<T extends BaseWidget = BaseWidget> extends Type<T> {}

export type WidgetFactory = BaseWidgetFactory<WidgetConstructor>;

// Injection token for WidgetFactory.
// Use this token to provide a widget factory implementation in Angular's DI system.
export const WIDGET_FACTORY = new InjectionToken<WidgetFactory>('WIDGET_FACTORY');
